module.exports = __webpack_public_path__ + "static/the-road-e7e1f5f70bd4ec30662563d59b153bd1.jpg";